export default __webpack_public_path__ + "static/media/A001.4ff1bf0f.mp3";